import { AppInstanceConfigBlobDefinitionsState } from './types';
import { createReducer } from 'typesafe-actions';
import * as actions from './actions';
import { combineReducers } from 'redux';

export const initialState: AppInstanceConfigBlobDefinitionsState = {
  data: {},
  currentDefinitionKey: null,
};

export const data = createReducer(initialState.data)
  .handleAction(actions.getAppInstanceConfigBlobDefinition.request, (state, action) => ({
    ...state,
    [action.payload]: { loading: true, data: null, error: null },
  }))
  .handleAction(actions.getAppInstanceConfigBlobDefinition.success, (state, action) => ({
    ...state,
    [action.payload.uuid]: { loading: false, data: action.payload.data, error: null },
  }))
  .handleAction(actions.getAppInstanceConfigBlobDefinition.failure, (state, action) => ({
    ...state,
    [action.payload.uuid]: { loading: false, data: null, error: action.payload.error },
  }));

export const currentDefinitionKey = createReducer(initialState.currentDefinitionKey).handleAction(
  actions.selectAppInstanceConfigBlobDefinition,
  (_state, action) => action.payload,
);

export default combineReducers({ data, currentDefinitionKey });
